module.exports = __webpack_public_path__ + "static/media/SereniaLifeLogo_Fullcolour.00f812a5.svg";